const dateFormat = /^(0[1-9]|10|11|12)\/(0[1-9]|[1-2][0-9]|3[0-1])\/(19|[2-9]\d)\d{2}$/;

export const formatDate = (value) => {
    const date = new Date(value);
    if (date) {
        return date.toLocaleDateString([], { year: 'numeric', month: 'long', day: 'numeric' });
    }
    else {
        return value;
    }
};

export const formatTime = (value) => {
    const date = new Date(value);
    if (date) {
        return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    }
    else {
        return value;
    }
};

export const isValidDate = (value) => {
    let noMonthShift = true;
    let dateValue = null;
    if (value instanceof Date) {
        dateValue = value;
    }
    else {
        if (!value || !dateFormat.test(value)) {
            return false;
        }
        dateValue = new Date(value);
        noMonthShift = Number(value.substr(0, 2)) === dateValue.getMonth() + 1;
    }
    return noMonthShift;
};

export const removeTime = (date) => {
    if (isValidDate(date)) {
        date = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    }
    return date;
};

export const getAge = date => {
    var ageDifMs = Date.now() - new Date(date).getTime();
    var ageDate = new Date(ageDifMs); // miliseconds from epoch
    return Math.abs(ageDate.getUTCFullYear() - 1970);
};

const getDate = date => {
    if (!date) {
        return null;
    }
    else if (typeof date === 'string') {
        return date.indexOf('Z') === -1 ? new Date(date + 'Z') : new Date(date);
    }
    if (date.getTime) {
        return date;
    }
    else {
        return null;
    }
};

export const timeDiff = (date1, date2) => {
    date1 = getDate(date1);
    if (date1 && !isNaN(date1)) {
        let delta = (getDate(date2) - date1) / 1000; // total seconds between the times

        // calculate (and subtract) whole days
        const days = Math.floor(delta / 86400);
        delta -= days * 86400;

        // calculate (and subtract) whole hours
        const hours = Math.floor(delta / 3600) % 24;
        delta -= hours * 3600;

        // calculate (and subtract) whole minutes
        const minutes = Math.floor(delta / 60) % 60;
        delta -= minutes * 60;

        // what's left is seconds
        const seconds = Math.floor(delta % 60);

        return { days, hours, minutes, seconds };
    }
    else {
        return null;
    }
};